import category from './category'
import client from './client'
import staff from './staff'
import business from './business'
import banner from './banner'
import topList from './top-list'
import page from './page'
import recommendationBusiness from './recommendation-list'

let routes = [{
  path: '/dashboard',
  name: 'Dashboard',
  component: () => import('@/views/admin/dashboard/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Dashboard',
    breadcrumb: [{
      title: 'Home',
      active: true
    }],
  }
}]

export default routes.concat(category, client, business, staff, banner, topList, page, recommendationBusiness)
